<template>
  <ElButton type="primary" :loading="loading" @click="submitForm">
    <slot>提交</slot>
  </ElButton>
</template>

<script lang="ts">
/**
 * ### 表单提交按钮组件
 */
import { defineComponent, PropType } from 'vue';
import { ElButton } from 'element-plus';
import { useShareData } from '../../core/SharedData';
import { PlainObject } from '../../core/types';
import { FormSubmit } from '../types';
import { assign } from 'lodash-es';

type HookFunc = (data: PlainObject) => boolean | undefined;

export default defineComponent({
  extends: [ElButton],

  props: {
    /**
     * ### 表单提交控制句柄 传入的参数为表单提交函数
     */
    handle: {
      type: Function as PropType<(submit: FormSubmit) => void | Promise<void>>,
      default: undefined
    },
    /**
     * ### 提交前hook函数 返回false时阻止提交
     */
    before: {
      type: Function as PropType<(data: PlainObject) => boolean | undefined>,
      default: undefined
    },
    /**
     * ### 提交后hook
     */
    after: {
      type: Function as PropType<(data: any) => void>,
      default: undefined
    },
    /**
     * ### 补充的提交参数
     */
    extra: { type: Object as PropType<PlainObject>, default: undefined }
  },

  setup(props) {
    const submit = useShareData('form', 'submit');
    const loading = useShareData('form', 'loading');

    // eslint-disable-next-line vue/no-setup-props-destructure
    let before = props.before;
    if (props.extra) {
      before = (data) => {
        // 把补充参数补上
        assign(data, props.extra);
        return props.before?.(data);
      };
    }

    const realSubmit = (hookFunc?: HookFunc) =>
      submit({
        before: (data: PlainObject) => {
          if (before && before(data) === false) {
            return false;
          }

          return hookFunc?.(data);
        },
        after: props.after
      });

    const submitForm = () => {
      if (props.handle) {
        return props.handle(realSubmit);
      } else {
        return submit({
          before: before,
          after: props.after
        });
      }
    };

    return { submitForm, loading };
  }
});
</script>
